import React from 'react';
import commonUtil from '../../utils/commonUtil';
// import './Warning.css';

class Warning extends React.Component {
  constructor() {
    super();
    this.hideErrorMsg = this.hideErrorMsg.bind(this);
    this.hidewarningMsg = this.hidewarningMsg.bind(this);
    this.hideSuccessMsg = this.hideSuccessMsg.bind(this);
    // this.setState({ warningMessage: this.props.text || '' });
  }
  state = {
    warningMessage: '',
  };
  hideErrorMsg() {
    this.errormsg.style.display = 'none';
    this.setState({ warningMessage: '' });
  }
  hidewarningMsg() {
    this.warningmsg.style.display = 'none';
    this.setState({ warningMessage: '' });
  }
  hideSuccessMsg() {
    this.successmsg.style.display = 'none';
    this.setState({ warningMessage: '' });
  }
  setMessage = (message) => {
    this.setState({ warningMessage: message });
    if (message && !this.props.notSetToTop) {
      commonUtil.goToTop();
    }
  }
  /* eslint-disable */
  render() {
    // const WarningContent = this.props.text;
    if (!this.state.warningMessage) {
      return null;
    }
    const type = this.props.type;
    const style = this.props.style;
    if (type === 'error') {
      return (
        <div className="alertError" ref={errormsg => this.errormsg = errormsg} style={{ display: (this.state.warningMessage) ? 'block' : 'none', ...style }}><i className="icon-tache2" />
          <p>{this.state.warningMessage}</p><a className="icon-tache2" onClick={this.hideErrorMsg} />
        </div>);
    } else if (type === 'warning') {
      return (
        <div className="alertWarning typeEventWarning" ref={warningmsg => this.warningmsg = warningmsg} style={{ display: (this.state.warningMessage) ? 'block' : 'none', ...style }}><i className="icon-alerta_amarilla" />
          <p> {this.state.warningMessage}</p><a className="icon-tache2" onClick={this.hidewarningMsg} />
        </div>);
    } else if (type === 'success') {
      return (
        <div className="alertSuccess" ref={successmsg => this.successmsg = successmsg} style={{ display: (this.state.warningMessage) ? 'block' : 'none', ...style }}><i className="icon-check" />
          <p> {this.state.warningMessage}</p><a className="icon-tache2" onClick={this.hideSuccessMsg} />
        </div>);
    }
    return null;
  }
}

export default Warning;

